import { render } from "./CrudSubareas.vue?vue&type=template&id=318f7a00&scoped=true"
import script from "./CrudSubareas.vue?vue&type=script&lang=js"
export * from "./CrudSubareas.vue?vue&type=script&lang=js"

import "./CrudSubareas.vue?vue&type=style&index=0&id=318f7a00&lang=css"
import "./CrudSubareas.vue?vue&type=style&index=1&id=318f7a00&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318f7a00"]])

export default __exports__